import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import T from 'prop-types';

import KpiSpotlightQV from './KpiSpotlightQV';
import Header from '../Header';
import PreHeader from '../PreHeader';
import DriversQV from '../DriversQV';

import {
  activeEntitySelector,
  permissionsSelector,
  quickViewDataSelector,
  quickViewSettingsSelector,
} from '../../../selectors';
import { ASSET } from '../../../configs/constants';

const { company_data, mpi_spotlight, kpi_spotlight, drivers } = ASSET;

const emptyObject = {};

const FinanceQVContent = ({ onClose }) => {
  const data = useSelector(quickViewDataSelector);
  const { cqv } = useSelector(quickViewSettingsSelector);
  const activeEntity = useSelector(activeEntitySelector);
  const permissions = useSelector(permissionsSelector);

  const companyData = data[company_data] || emptyObject;
  const activeCompanyData = useMemo(
    () => ({
      ...activeEntity,
      ...companyData,
    }),
    [companyData, activeEntity]
  );

  const kpiSpotlightSettings = {
    ...cqv[kpi_spotlight],
    ...cqv[mpi_spotlight],
    pending: cqv[company_data].pending || cqv[kpi_spotlight].pending,
  };
  const driversSettings = {
    ...cqv[drivers],
    pending: cqv[company_data].pending || cqv[drivers].pending,
  };

  const kpiSpotlightData = !isEmpty(data[mpi_spotlight])
    ? data[mpi_spotlight]
    : data[kpi_spotlight];

  return (
    <>
      <PreHeader companyData={activeCompanyData} settings={cqv[company_data]} onClose={onClose} />
      <div className="company-quick-view__scrollable-container">
        <Header
          companyData={activeCompanyData}
          settings={cqv[company_data]}
          showKpiTrackingIndicator={permissions.allowFinanceLP}
          onClose={onClose}
        />
        <div className="company-quick-view__finance-content-wrapper">
          <KpiSpotlightQV
            data={kpiSpotlightData}
            company={activeCompanyData}
            settings={kpiSpotlightSettings}
          />
          <DriversQV data={data[drivers]} settings={driversSettings} />
        </div>
      </div>
    </>
  );
};

FinanceQVContent.propTypes = {
  onClose: T.func.isRequired,
};

export default FinanceQVContent;
